export const RADIUS_OPTIONS = [
  { value: 0, class: "rounded-none" }, // 0px
  { value: 4, class: "rounded-sm" }, // 4px
  { value: 8, class: "rounded-lg" }, // 8px (Estándar)
  { value: 12, class: "rounded-xl" }, // 12px
  { value: 20, class: "rounded-3xl" }, // 20px
  { value: 99, class: "rounded-full" }, // Full
];
